(function () {
  // carousel_tab_horizontal中每一页宽度的设置
  function setCarouselTabHorizontalPageWidth() {
    const carousel_tab_horizontal = document.getElementsByClassName('carousel_tab_horizontal')
    let timeoutid = -1

    function _setCarouselTabHorizontalPageWidth() {
      const documentWidth = document.documentElement.clientWidth + 18

      for (let i = 0; i < carousel_tab_horizontal.length; i++) {
        const tabContentBlockWrap = carousel_tab_horizontal[i].getElementsByClassName('tab-content-block-wrap')[0]
        const tabContentBlock = carousel_tab_horizontal[i].getElementsByClassName('tab-content-block')
        const tabContentInnerWrap = carousel_tab_horizontal[i].getElementsByClassName('tab-content-inner-wrap')[0]

        let totaltabContentBlockWidth = 0
        for (let i = 0; i < tabContentBlock.length; i++) {
          totaltabContentBlockWidth += tabContentInnerWrap.offsetWidth
          tabContentBlock[i].style.width = tabContentInnerWrap.offsetWidth + 'px'

          const innerWrap = tabContentBlock[i].getElementsByClassName('inner-wrap')[0]
          const imgRow = innerWrap.getElementsByClassName('img-row')[0]
          const imgCols = imgRow.getElementsByClassName('img-col')

          const innerWrapWidth = tabContentInnerWrap.offsetWidth
          innerWrap.style.width = innerWrapWidth + 'px'

          let tatalColsWidth = 0
          for (let j = 0; j < imgCols.length; j++) {
            const width = parseFloat(innerWrap.style.width)
            tatalColsWidth += width
            imgCols[j].style.width = width + 'px'
          }
          imgRow.style.width = tatalColsWidth + 'px'
          imgRow.style.left = '0px'
        }
        tabContentBlockWrap.style.width = totaltabContentBlockWidth + 'px'
        tabContentBlockWrap.style.left = '0px'
      }
    }

    window.addEventListener('resize', debounce(() => {
      for (let i = 0; i < carousel_tab_horizontal.length; i++) {
        let tabs = carousel_tab_horizontal[i].getElementsByClassName('tab')
        try {
          Array.from(tabs).forEach(tab => {
            if (tab.dataset.hover) {
              _setCarouselTabHorizontalPageWidth()
              if (tab.dataset.index != 0) {
                const temp = tab.dataset.index
                let tabContentBlockWrap = carousel_tab_horizontal[i].getElementsByClassName('tab-content-block-wrap')[0]
                let tabContentBlock = tabContentBlockWrap.getElementsByClassName('tab-content-block')
                let innerWrap = tabContentBlock[temp].getElementsByClassName('inner-wrap')
                let pageInfo = tabContentBlock[temp].getElementsByClassName('desc')[0].getElementsByTagName('span')
                let imgRow = innerWrap[0].getElementsByClassName('img-row')[0]
                let totalimgRowLeft = 0
                for (let j = 0;j < pageInfo.length;j++){
                  if (pageInfo[j].style.display != 'none') {
                    imgRow.style.left = '-' + totalimgRowLeft + 'px'
                  }
                  totalimgRowLeft += innerWrap[0].offsetWidth
                }
                //当前页码决定imgRowLeft
                //当前Tab决定tabContentBlockWrapLeft
                tabContentBlockWrap.style.left = '-' + tabContentBlock[temp - 1].getElementsByClassName('img-row')[0].style.width
              }
              throw new Error('EndIterative')
            }
          })
        } catch (e) {
          if (e.message != 'EndIterative') throw e
        }
      }
    }, 500))

    _setCarouselTabHorizontalPageWidth()



    function _addEvent() {
      for (let i = 0; i < carousel_tab_horizontal.length; i++) {
        // 顶部切换tab相关
        const tabsWrap = carousel_tab_horizontal[i].getElementsByClassName('tabs')[0]
        const tabs = tabsWrap.getElementsByClassName('tab')
        tabs[0].dataset.hover = 'true'

        const tabContentInnerWrap = carousel_tab_horizontal[i].getElementsByClassName('tab-content-inner-wrap')[0]
        const tabContentBlockWrap = carousel_tab_horizontal[i].getElementsByClassName('tab-content-block-wrap')[0]
        const tabContentBlock = carousel_tab_horizontal[i].getElementsByClassName('tab-content-block')

        function tabChange(tabIndex) {
          // 设置tab的hover
          for (let i = 0; i < tabs.length; i++) {
            if (tabs[i].dataset.index === tabIndex) {
              tabs[i].dataset.hover = 'true'
            } else {
              delete tabs[i].dataset.hover
            }
          }

          //重置所有tab种内容wrap的初始位置
          for (let i = 0; i < tabContentBlock.length; i++) {
            if (parseInt(tabIndex) === i) {
              tabContentBlock[i].style.opacity = 1
              continue
            }
            tabContentBlock[i].style.opacity = 0
            const imgRow = tabContentBlock[i].getElementsByClassName('img-row')[0]
            const pageInfo = tabContentBlock[i].getElementsByClassName('page-info')[0]
            const totalPage = pageInfo.innerText.split('/')[1]
            pageInfo.innerText = '1/' + totalPage
            const descSpans = tabContentBlock[i].getElementsByClassName('desc')[0].getElementsByTagName('span')
            for (let j = 0; j < descSpans.length; j++) {
              if (descSpans[j].dataset.index === '0') {
                descSpans[j].style.display = 'inline'
              } else {
                descSpans[j].style.display = 'none'
              }
            }
            imgRow.style.left = '0px'
          }

          // 设置tab位置
          tabContentBlockWrap.style.left = -parseFloat(tabIndex) * tabContentInnerWrap.offsetWidth + 'px'
        }

        // 点击tab跳转
        tabsWrap.addEventListener('click', throttle(function (event) {
          //重置计时
          clearTimeout(timeoutid)
          tabChange(event.target.dataset.index)
          timeoutid = setTimeout(carouselTabHorizontalSwipter.bind(this), 7000)
        }, 800))




        // tab种内容切换相关
        const controllerLeft = carousel_tab_horizontal[i].querySelector('.tab-content-wrap > .controller-left > span')
        const controllerRight = carousel_tab_horizontal[i].querySelector('.tab-content-wrap > .controller-right > span')

        function getCurrentTabIndex() {
          let index = 0
          Array.from(tabs).some(tab => {
            if (tab.dataset.hover === 'true') {
              index = parseInt(tab.dataset.index)
              return true
            }
            return false
          })
          return index
        }

        function next() {
          const currentTabIndex = getCurrentTabIndex()
          const descSpans = tabContentBlock[currentTabIndex].getElementsByClassName('desc')[0].getElementsByTagName('span')
          const pageInfo = tabContentBlock[currentTabIndex].getElementsByClassName('page-info')[0]
          const imgRow = tabContentBlock[currentTabIndex].getElementsByClassName('img-row')[0]
          const [currentPage, totalPage] = pageInfo.innerText.split('/').map(item => parseInt(item.trim()))
          const innerWrap = tabContentBlock[currentTabIndex].getElementsByClassName('inner-wrap')[0]

          if (currentPage >= totalPage) {
            let nextTabIndex = 0
            if (currentTabIndex + 1 >= tabs.length) {
              // 返回第一个tab
              nextTabIndex = 0
            } else {
              // 换下一个tab
              nextTabIndex = currentTabIndex + 1
            }
            tabChange(nextTabIndex + '')
          } else {
            // 本tab的下一页内容
            pageInfo.innerText = currentPage + 1 + '/' + totalPage
            for (let i = 0; i < descSpans.length; i++) {
              if (descSpans[i].dataset.index === currentPage + '') {
                descSpans[i].style.display = 'inline'
              } else {
                descSpans[i].style.display = 'none'
              }
            }
            imgRow.style.left = -currentPage * innerWrap.offsetWidth + 'px'
          }
        }

        function prev() {
          const currentTabIndex = getCurrentTabIndex()
          const descSpans = tabContentBlock[currentTabIndex].getElementsByClassName('desc')[0].getElementsByTagName('span')
          const pageInfo = tabContentBlock[currentTabIndex].getElementsByClassName('page-info')[0]
          const imgRow = tabContentBlock[currentTabIndex].getElementsByClassName('img-row')[0]
          const [currentPage, totalPage] = pageInfo.innerText.split('/').map(item => parseInt(item.trim()))
          const innerWrap = tabContentBlock[currentTabIndex].getElementsByClassName('inner-wrap')[0]

          if (currentPage <= 1) {
            if (currentTabIndex > 0) {
              tabChange(currentTabIndex - 1 + '')
            }
          } else {
            pageInfo.innerText = currentPage - 1 + '/' + totalPage
            for (let i = 0; i < descSpans.length; i++) {
              if (descSpans[i].dataset.index === currentPage - 2 + '') {
                descSpans[i].style.display = 'inline'
              } else {
                descSpans[i].style.display = 'none'
              }
            }
            imgRow.style.left = -(currentPage - 2) * innerWrap.offsetWidth + 'px'
          }
        }

        controllerLeft.addEventListener('click', throttle(() => {
          carouselTabHorizontalSwipter('prev')
        }, 800))
        controllerRight.addEventListener('click', throttle(() => {
          carouselTabHorizontalSwipter()
        }, 800))

        //carouselTabHorizontal轮播
        function carouselTabHorizontalSwipter(direction) {
          //重置计时
          clearTimeout(timeoutid)
          if (direction === 'prev') {
            prev()
          } else {
            next()
          }
          timeoutid = setTimeout(carouselTabHorizontalSwipter.bind(this), 7000)
        }
        timeoutid = setTimeout(carouselTabHorizontalSwipter.bind(this), 7000)
      }
    }

    _addEvent()
  }


  setCarouselTabHorizontalPageWidth()

})()